// @ts-nocheck
import * as React from "react";

/* Store Custom Code - Start */
import { IconOffset } from "@toolkit/Framework/Types/Icon";
/* Store Custom Code - End */

const EyeFill: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                d="M12.004 15.154c1.016 0 1.878-.356 2.586-1.067.709-.712 1.063-1.575 1.063-2.591 0-1.017-.356-1.879-1.067-2.587-.711-.709-1.575-1.063-2.591-1.063-1.016 0-1.879.356-2.587 1.067-.708.712-1.063 1.575-1.063 2.591 0 1.017.356 1.879 1.067 2.587.712.709 1.575 1.063 2.592 1.063Zm-.005-.954c-.75 0-1.387-.262-1.912-.787a2.604 2.604 0 0 1-.788-1.913c0-.75.263-1.387.788-1.912a2.604 2.604 0 0 1 1.912-.788c.75 0 1.388.262 1.913.787.525.526.787 1.163.787 1.913s-.262 1.387-.787 1.912a2.604 2.604 0 0 1-1.913.788Zm.003 3.8c-2.166 0-4.14-.59-5.922-1.768-1.782-1.18-3.117-2.756-4.004-4.732.887-1.976 2.221-3.553 4.001-4.732C7.857 5.59 9.83 5 11.997 5c2.165 0 4.14.59 5.921 1.768 1.782 1.18 3.117 2.756 4.004 4.732-.887 1.976-2.22 3.553-4 4.732C16.14 17.41 14.167 18 12.001 18Zm-.003-1a9.544 9.544 0 0 0 5.188-1.488 9.774 9.774 0 0 0 3.612-4.012 9.773 9.773 0 0 0-3.612-4.013A9.545 9.545 0 0 0 11.999 6a9.545 9.545 0 0 0-5.187 1.487A9.773 9.773 0 0 0 3.199 11.5a9.773 9.773 0 0 0 3.613 4.012A9.544 9.544 0 0 0 11.999 17Z"
            />
        </svg>
        /* Store Custom Code - End */
    );
};

/* Store Custom Code - Start */
export const EyeFillOffset: IconOffset = {
    vertical: 20,
    horizontal: 8,
};
/* Store Custom Code - End */

export default React.memo(EyeFill);
